module.exports = __webpack_public_path__ + "img/tier1-1.2fd3c704.png";